import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";

const COOKIE_KEY = "cookie_consent";
const SESSION_KEY = "cookie_seen_session";

const setCookieConsent = (value) => {
    const data = {
        value,
        expiry: new Date().getTime() + 6 * 30 * 24 * 60 * 60 * 1000, // 6 months
    };
    localStorage.setItem(COOKIE_KEY, JSON.stringify(data));
};

const getCookieConsent = () => {
    try {
        const stored = localStorage.getItem(COOKIE_KEY);
        if (!stored) return null;

        const parsed = JSON.parse(stored);

        if (!parsed?.expiry || new Date().getTime() > parsed.expiry) {
            localStorage.removeItem(COOKIE_KEY);
            return null;
        }

        return parsed.value;
    } catch (e) {
        localStorage.removeItem(COOKIE_KEY);
        return null;
    }
};

const CookieConsent = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = getCookieConsent();
        const seenSession = sessionStorage.getItem(SESSION_KEY);

        if (!consent && !seenSession) {
            setTimeout(() => {
                setVisible(true);
                sessionStorage.setItem(SESSION_KEY, "true");
            }, 500);
        }

        if (consent === "accepted") {
            // initAnalytics();
        }
    }, []);

    const handleAccept = () => {
        setCookieConsent("accepted");
        setVisible(false);

        // initAnalytics();
    };

    const handleDecline = () => {
        setCookieConsent("declined");
        setVisible(false);
    };

    if (!visible || window.location.pathname.includes('-chart/')) return null;

    return (
        <div className="cookie-wrapper">
            <div className="cookie-box">
                <div className="cookie-text">
                    <h6>🍪 Cookies & Privacy</h6>
                    <p>
                        We use cookies to enhance your experience, analyze traffic, and
                        improve our services. By clicking <strong>Accept</strong>, you agree
                        to our cookie usage.
                    </p>
                </div>

                <div className="cookie-actions">
                    <Button
                        variant="outlined"
                        onClick={handleDecline}
                        className="cookie-btn decline"
                    >
                        Decline
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleAccept}
                        className="cookie-btn accept"
                    >
                        Accept All
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;